import { Row, Col } from "react-bootstrap";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AlertComponent from "./AlertComponent";

const ChurchModal = (props) => {
  const {
    invisible,
    setInvisible,
    title,
    content,
    createItem = `Create`,
    discardItem = `Discard & Close`,
    onSubmit,
    messageTitle = `Success`,
    message = ``,
  } = props;
  const handleClose = () => setInvisible(false);
  const submitItem = () => {
    AlertComponent(messageTitle, message);
    setInvisible(false);
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <Modal
      show={invisible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
          <h5 onClick={handleClose}>{title}</h5>
          <div className="message-body">{content}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary cs-cancel-btn" onClick={handleClose}>
          {discardItem}
        </Button>
        <Button variant="primary dark-btn" onClick={submitItem}>
          {createItem}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ChurchModal;
